import React, { useState, useEffect } from "react";

import { GetSingleAncillaryResponse } from "../../../../../common/api/catalogue-api/ancillary/GetSingleAncillaryResponse";
import { useCatalogueAncillarySearchApi } from "../../../../../common/api/catalogue-api/ancillary/useCatalogueAncillarySearchApi";
import { ContentReferenceType } from "../../../../../common/types/ContentReferenceType";
import { useFileRecordDetailsState } from "../../../../file-records/details/hooks/useFileRecordDetailsState";
import { BuzzVersionsList } from "../../../buzz-version/BuzzVersionsList";
import { MediaBuzzVersion, mapAncillaryToMediaBuzzVersion } from "../../../buzz-version/MediaBuzzVersion";
import { ContentAssociationAncillaryDetails } from "../../../content/types/ContentAssociationDetails";
import { checkIsInactiveContentSelected } from "../../../content/utils/checkIsInactiveContentSelected";

interface FileRecordAncillaryVersionInfoProps {
    ancillaryId: string;
}

export const FileRecordAncillaryVersionInfo = (props: FileRecordAncillaryVersionInfoProps): JSX.Element => {
    const { ancillaryId } = props;

    const { getSingleAncillary } = useCatalogueAncillarySearchApi();

    const [isLoading, setIsLoading] = useState<boolean>(true);

    const [ancillaryVersion, setAncillaryVersion] = useState<MediaBuzzVersion[]>([]);

    const { setIsArchivedContentAssigned } = useFileRecordDetailsState();

    useEffect(() => {
        setIsLoading(true);

        getSingleAncillary(ancillaryId)
            .then((response: GetSingleAncillaryResponse) => {
                const version = mapAncillaryToMediaBuzzVersion(response.version);

                const isArchivedContentAssigned = checkIsInactiveContentSelected(
                    mapToContentAssociationDetails(response)
                );

                setIsArchivedContentAssigned(isArchivedContentAssigned);

                setAncillaryVersion([version]);
            })
            .finally(() => setIsLoading(false));
    }, [ancillaryId]);

    return <BuzzVersionsList versions={ancillaryVersion} isLoading={isLoading} />;
};

const mapToContentAssociationDetails = (response: GetSingleAncillaryResponse): ContentAssociationAncillaryDetails => {
    return {
        id: response.id,
        title: response.title,
        source: response.source,
        type: ContentReferenceType.Ancillary,
        buzz: response.buzz,
        subtype: response.subtype,
        isMerged: !!response.mergedTargetId,
        version: response.version
    };
};
